import React, { Component } from 'react';
import { signUpUser, authError } from '../../actions';
import { connect } from 'react-redux';
import { Form, FormGroup, FormControl, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Signin.css';

class Signup extends Component{
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      confirmPassword: '',
      code: ''
    };
  }

  componentDidMount() {
    this.props.authError('');    
  }

  handleFormSubmit = (e) => {
    e.preventDefault();
    this.props.signUpUser({ 
      email: this.state.email, 
      password: this.state.password, 
      code: this.state.code,
      history: this.props.history      
    });
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  renderAlert = () => {
    if (this.props.auth.errorMessage) {
      return (
        <Alert bsStyle="danger">
          <strong>Oops!</strong> {this.props.auth.errorMessage}
        </Alert>
      );
    }
  }
  
  render() {
    return (
      <div className="signin-container">
        <div className="card">
          <div className="header">Sign Up</div>
          <Form onSubmit={this.handleFormSubmit}>
            <FormGroup controlId="email">
              <FormControl 
                bsSize="large"
                type="email" 
                placeholder="Email Address" 
                value={this.state.email} 
                name="email" 
                required
                onChange={(e) => this.onInputChange(e)} />
            </FormGroup>
            <FormGroup controlId="password">
              <FormControl 
                bsSize="large"
                type="password" 
                placeholder="Password" 
                value={this.state.password} 
                name="password" 
                required
                onChange={(e) => this.onInputChange(e)} />
            </FormGroup>
            <FormGroup controlId="confirmPassword">
              <FormControl 
                bsSize="large"
                type="password" 
                placeholder="Confirm Password" 
                value={this.state.confirmPassword} 
                name="confirmPassword" 
                required
                onChange={(e) => this.onInputChange(e)} />
            </FormGroup>
            <FormGroup controlId="accessCode">
              <FormControl 
                bsSize="large"
                type="text" 
                placeholder="Access Code" 
                value={this.state.code} 
                name="code" 
                required
                onChange={(e) => this.onInputChange(e)} />
            </FormGroup>
            {this.renderAlert()}
            <Button 
              bsSize="large"
              className="btn-signin" 
              bsStyle="primary" 
              type="submit"
            >Sign Up</Button>
          </Form>
        </div>
        <p className="signup-link">Already have an account? <Link to="/signin">Log In!</Link></p>
      </div>
    );
  }
}

function mapStateToProps ({ auth }) {
  return {
    auth
  }
}

export default connect(mapStateToProps, { signUpUser, authError })(Signup);
